/* eslint-disable react/no-unused-state */
import React from 'react';

import cn from 'classnames';
import ContentEditable from 'react-contenteditable';

import { IframeTunnel } from 'common/utils/iframe-tunnel';
import { isLayerType } from 'common/utils/is-layer-type';
import { triggerFocus } from 'common/utils/helpers';
import { IFRAME_ACTIONS, UNIFORM_PROPS } from 'common/constants';
import css from './Error.scss';

function transmitUpdatedValueToAdmin({ path, value, isStory }) {
	const iframeTunnel = new IframeTunnel({ id: 'ErrorEditable' });
	iframeTunnel.messageTransmitter({
		target: IframeTunnel.targets.admin,
		action: IFRAME_ACTIONS[isStory ? 'UPDATE_STORY_ELEMENT_BY_PATH' : 'UPDATE_CARD_ELEMENT_BY_PATH'],
		payload: {
			path,
			value,
		},
	});
}

type OwnState = any;

type State = OwnState & typeof ErrorEditable.defaultProps;

type Props = {
	text: string;
	errorType: string;
	path?: string;
};
class ErrorEditable extends React.Component<Props, State> {
	static defaultProps = {
		path: '',
	};

	editableRef = React.createRef<HTMLElement>();

	constructor(props, context) {
		super(props, context);

		this.state = {
			htmlPrev: props.text,
			html: props.text,
			editing: false,
		};
	}

	static getDerivedStateFromProps({ text }, state) {
		const isUpdatedChildrenFromProp = text !== state.htmlPrev;
		if (isUpdatedChildrenFromProp) {
			return { html: text, htmlPrev: text };
		}
		return null;
	}

	onEditablePaste = event => {
		// cancel paste
		event.preventDefault();
		// get text representation of clipboard
		const text = (event.originalEvent || event).clipboardData.getData('text/plain');
		// insert text manually
		const command = document.queryCommandSupported('insertText') ? 'insertText' : 'paste';
		document.execCommand(command, false, text);
	};

	onEditableBlur = event => {
		const { path: p, errorType } = this.props;
		const path = `elements.${p}.uiConfig.componentProps.${UNIFORM_PROPS.fieldError}.${errorType}`;

		if (isLayerType(this.props).global) {
			transmitUpdatedValueToAdmin({
				path,
				value: this.state.html,
				isStory: true,
			});
		} else {
			transmitUpdatedValueToAdmin({
				path,
				value: this.state.html,
				isStory: false,
			});
		}

		this.setState({ editing: false });
	};

	onEditableChange = event => {
		this.setState({ html: event.target.value });
		// trigger SelectionHint update to set current editable node sizes
		triggerFocus(this.editableRef.current);
	};

	onEditableDoubleClick = () => {
		this.setState({ editing: true }, () => {
			this.editableRef.current?.focus();
		});
	};

	render() {
		return (
			<ContentEditable
				// data-key={+Date.now()}
				innerRef={this.editableRef}
				className={cn(css.editable /* , Date.now() */)}
				html={this.state.html}
				tagName="span"
				disabled={!this.state.editing}
				onDoubleClick={this.onEditableDoubleClick}
				onChange={this.onEditableChange}
				onBlur={this.onEditableBlur}
				onPaste={this.onEditablePaste}
			/>
		);
	}
}

export { ErrorEditable };
